import React from 'react';

const Card = ({ children, className }) => <div className={`plan-card ${className ? className : ''}`}>{children}</div>;

export default Card
